<template>
	<div class="calendarEventsMonth">
		<div class="title">{{ item.month }}</div>
		<div class="days head">
			<div v-for="(day, index) in daysHead" :key="index" :item="day">
				{{ day }}
			</div>
		</div>
		<div class="days">
			<calendar-events-day
					v-for="(day, index) in item.days"
					:key="index"
					:item="day"
			></calendar-events-day>
		</div>
		<div v-if="holidaysList.length" class="itemMonth">
			<div class="itemMonthTitle">Holidays 🤟🥳💃 :</div>
			<ul>
				<li v-for="(holiday, index) in holidaysList" :key="index">
					{{ formattedDate(holiday.date) }} - {{ holiday.isHolidays }}
				</li>
			</ul>
		</div>
		<div v-if="usersList.length" class="usersList">
			<div class="usersListTitle">Users 📅:</div>
			<ul>
				<li v-for="(user, index) in usersList" :key="index" class="item">
					<span :style="{ color: user.color }">●</span>
					<b>{{ user.name }}</b>
					- {{ user.dates.length }}
					<small
							v-for="(date, index) in user.dates"
							:key="index"
					>
						{{ formattedDate(date) }}
					</small>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import CalendarEventsDay from "@/pages/Account/Tabs/CalendarEventsDay/CalendarEventsDay.vue";

export default {
	name: "CalendarEventsMonth",
	components: { CalendarEventsDay },
	props: {
		item: Object,
	},

	data() {
		return {
			daysHead: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
			holidaysList: [],
			usersList: [],
		};
	},
	methods: {
		generateUsersList(days) {
			const userMap = {};

			days.forEach((day) => {
				if (day.users) {
					day.users.forEach((user) => {
						if (!userMap[user.id]) {
							userMap[user.id] = { id: user.id, name: user.name, color: user.color, dates: [] };
						}
						userMap[user.id].dates.push(day.date);
					});
				}
			});

			this.usersList = Object.values(userMap);
		},
		formattedDate(date) {
			if (!date) return '';
			return date.split('-')[2]; // Возвращаем третий элемент, день месяца
		},
	},
	watch: {
		item: {
			immediate: true,
			handler(newItem) {
				if (newItem?.days) {
					this.holidaysList = newItem.days.filter(day => day.isHolidays && day.isHolidays !== false);
					this.generateUsersList(newItem.days);
				}
			},
		},
	},
};
</script>

<style lang="scss">
	@import "calendarEventsMonthAll";
</style>
<style scoped lang="scss">
	@import "calendarEventsMonth";
</style>
